import styled from 'styled-components'

import { focusStylesWithRoundedEdges } from '@ilg-totallymoney/ui/styles/focus'
import theme from '@ilg-totallymoney/ui/theme'

export const StyledLoanDetailsModalButton = styled.button`
    width: 100%;
    background-color: white;
    height: 50px;
    padding: ${theme.space10} ${theme.space20};
    border-radius: ${theme.radii.borderRadius10};
    border: 1px solid ${theme.grey60};

    ${focusStylesWithRoundedEdges};

    &:hover {
        cursor: pointer;
    }

    p {
        font-family: ${theme.buenosAires};
    }

    span {
        font-family: ${theme.nunito};
    }
`
